import { Button as Button2, DataGrid } from "devextreme-react";
import {
  Button,
  Column,
  ColumnChooser,
  Editing,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  LoadPanel,
  Paging,
  Popup,
  Position,
  Scrolling,
  SearchPanel,
  Sorting,
  Texts,
  Toolbar,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { init, updateAll } from "./Redux/Tracker";
import axios from "axios";
import { classifMajList } from "../../PersonalRecord/data";
import { Item } from "devextreme-react/toolbar";
import { notifyMsg } from "../../common/notify";
import TrainingTrackerForm from "./TrainingTrackerForm";
import CompleteList from "./CompleteList";

import "./index.css";

const TrackerFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function TrainingTracker(props) {
  const { userInfo } = props;

  const dispatch = useDispatch();

  const trainingTracker = useSelector((state) => state.trainingTracker);

  const formTrackerRef = useRef(null);
  const triningTrackerGridRef = useRef(null);

  const [complListPopupVisible, setComplListPopupVisible] = useState(false);
  const [trackerPopupVisible, setTrackerPopupVisible] = useState(false);
  const [dataSource, setDataSource] = useState(
    new CustomStore({
      key: "id",
      load: async () => {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trk`
        );

        return result.data;
      },
      insert: async (values) => {
        await axios
          .post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trk`,
            values
          )
          .catch(function (error) {
            if (error) {
              console.error("error", error);

              notifyMsg(
                "에러가 발생했습니다. 관리자에게 문의해주세요",
                "error"
              );
            }
          });
      },
      update: async (key, values) => {
        await axios
          .put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trk/${key.id}`,
            values
          )
          .catch(function (error) {
            if (error) {
              console.error("error", error);

              notifyMsg(
                "에러가 발생했습니다. 관리자에게 문의해주세요",
                "error"
              );
            }
          });
      },
      remove: async (key) => {
        await axios
          .delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trk/${key}`
          )
          .catch(function (error) {
            if (error) {
              console.error("error", error);

              notifyMsg(
                "에러가 발생했습니다. 관리자에게 문의해주세요",
                "error"
              );
            }
          });
      },
    })
  );

  const onInitNewRow = (e) => {
    // e.data.admin = userInfo.employeeNo;

    if (formTrackerRef.current) {
      formTrackerRef.current.instance.option("formData", null);
    }

    dispatch(
      init({
        admin: userInfo.employeeNo,
        adminName: userInfo.name,
      })
    );

    setTrackerPopupVisible(true);
  };

  const contentRender = useCallback(() => {
    return (
      <TrainingTrackerForm
        trainingTracker={trainingTracker}
        formTrackerRef={formTrackerRef}
      />
    );
  }, [trainingTracker]);

  const onSaveClick = useCallback(() => {
    if (formTrackerRef.current.instance.validate().isValid) {
      setTrackerPopupVisible(false);

      if (trainingTracker.action == "insert") {
        triningTrackerGridRef.current.instance
          .getDataSource()
          .store()
          .insert({
            ...trainingTracker,
            trainee: formTrackerRef.current.instance.option("formData").trainee,
          })
          .then(() => {
            triningTrackerGridRef.current.instance.refresh();
          });
      } else if (trainingTracker.action == "update") {
        triningTrackerGridRef.current.instance
          .getDataSource()
          .store()
          .update(
            {
              id: trainingTracker.id,
            },
            {
              ...trainingTracker,
              trainee:
                formTrackerRef.current.instance.option("formData").trainee,
            }
          )
          .then(() => {
            triningTrackerGridRef.current.instance.refresh();
          });
      }
    }
  }, [trainingTracker]);

  const calculateDisplayValue = (data) => {
    return `${data.adminName} (${data.admin})`;
  };

  const calculateDisplayTraineeValue = (data) => {
    if (data.trainee) {
      let displayValue = ``;

      for (const trainee of data.trainee) {
        if (trainee.comp == "Y") {
          displayValue += `<span style="color:#007048">${trainee.traineeName} (${trainee.trainee})</span>, `;
          // displayValue += `${trainee.traineeName} (${trainee.trainee}), `;
        } else {
          // displayValue += `<span style="color:red">${trainee.traineeName} (${trainee.trainee})</span>, `;
          displayValue += `${trainee.traineeName} (${trainee.trainee}), `;
        }
      }

      displayValue = displayValue.substring(0, displayValue.length - 2);

      return displayValue;
    } else {
      return ``;
    }
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        action: "update",
      })
    );

    // if (formTrackerRef.current) {
    //   const formData = formTrackerRef.current.instance.option("formData");

    //   formTrackerRef.current.instance.option("formData", {
    //     ...formData,
    //     trainee: ["22040103", "23070301"],
    //   });
    // }

    setTrackerPopupVisible(true);
  };

  const disabled = (e) => {
    if (e.row.data.admin == userInfo.employeeNo) {
      return false;
    } else {
      return true;
    }
  };

  const onClick = () => {
    triningTrackerGridRef.current.instance.getDataSource().reload();
  };

  function calculateFilterExpression(filterValue, selectedFilterOperation) {
    if (selectedFilterOperation == "contains") {
      return function (rowData) {
        if (rowData.trainee && Array.isArray(rowData.trainee)) {
          return rowData.trainee.some(
            (obj) =>
              obj.traineeName == filterValue ||
              obj.trainee == filterValue ||
              obj.traineeName.includes(filterValue) ||
              obj.trainee.includes(filterValue)
          );
        }

        return false;
      };
    }

    // return [this.dataField, selectedFilterOperation, filterValue];
    return this.defaultCalculateFilterExpression.apply(this, arguments);
  }

  function calculateAdminDisplayValue(filterValue, selectedFilterOperation) {
    if (selectedFilterOperation == "=") {
      return function (rowData) {
        if (rowData.admin && rowData.adminName) {
          return (
            rowData.admin == filterValue || rowData.adminName == filterValue
          );
        }

        return false;
      };
    }

    return this.defaultCalculateFilterExpression.apply(this, arguments);
  }

  const onCompleteListIconClick = (e) => {
    dispatch(
      updateAll({
        ...e.row.data,
      })
    );

    setComplListPopupVisible(true);
  };

  return (
    <>
      <DataGrid
        id="triningTrackerGrid"
        ref={triningTrackerGridRef}
        dataSource={dataSource}
        keyExpr={"id"}
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        width={"100%"}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        height={"100%"}
        hoverStateEnabled={true}
        repaintChangesOnly={true}
        highlightChanges={true}
        onInitNewRow={onInitNewRow}
        onEditingStart={onEditingStart}
      >
        <LoadPanel enabled={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          showScrollbar={"always"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
        />
        <Grouping autoExpandAll={true} contextMenuEnabled={true} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />
        <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
          <Position
            my={"right top"}
            at={"right bottom"}
            of={".dx-datagrid-column-chooser-button"}
          />
        </ColumnChooser>

        <Editing
          refreshMode={"reshape"}
          mode={"popup"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Texts
            confirmDeleteMessage={"Are you sure want to delete this training?"}
            confirmDeleteTitle={"Delete the Tracker"}
          />
          <Popup
            visible={trackerPopupVisible}
            showTitle={true}
            title={"Training Tracker"}
            showCloseButton={true}
            height={"auto"}
            contentRender={contentRender}
          >
            <ToolbarItem
              widget={"dxButton"}
              toolbar={"top"}
              location={"after"}
              options={{
                icon: "save",
                type: "normal",
                stylingMode: "contained",
                onClick: onSaveClick,
              }}
            />
          </Popup>
        </Editing>

        <Toolbar>
          <Item location={"before"} name="groupPanel" />
          <Item name="addRowButton" />
          <Item location={"after"}>
            <Button2 icon="refresh" onClick={onClick} />
          </Item>
          <Item name="columnChooserButton" />
          <Item location={"after"} name="searchPanel" />
        </Toolbar>

        {/* <Column
        dataField={"type"}
        caption={"Training Type"}
        dataType={"string"}
        width={140}
        alignment={"center"}
      />
      <Column
        dataField={"cat"}
        caption={"Category"}
        dataType={"string"}
        width={110}
        alignment={"center"}
      /> */}
        <Column
          dataField={"title"}
          caption={"Training Title"}
          dataType={"string"}
          width={500}
          cssClass={"preserve-whitespace"}
        />
        <Column
          dataField={"startDate"}
          caption={"Start Date"}
          dataType={"date"}
          width={170}
          alignment={"center"}
          format={"yyyy-MM-dd"}
        />
        <Column
          dataField={"dueDate"}
          caption={"Due Date"}
          dataType={"date"}
          width={170}
          alignment={"center"}
          format={"yyyy-MM-dd"}
        />
        <Column
          dataField={"admin"}
          caption={"Administrator"}
          dataType={"string"}
          width={160}
          alignment={"center"}
          filterOperations={["="]}
          calculateDisplayValue={calculateDisplayValue}
          calculateFilterExpression={calculateAdminDisplayValue}
        />
        <Column
          dataField={"trainee"}
          caption={"Trainee"}
          dataType={"string"}
          encodeHtml={false}
          filterOperations={["contains"]}
          calculateDisplayValue={calculateDisplayTraineeValue}
          calculateFilterExpression={calculateFilterExpression}
        />
        <Column type={"buttons"}>
          <Button name={"edit"} disabled={disabled} />
          <Button name={"delete"} disabled={disabled} />
          <Button
            hint={"Complete List"}
            icon={"fa-solid fa-list"}
            disabled={disabled}
            onClick={onCompleteListIconClick}
          />
        </Column>
      </DataGrid>
      {trainingTracker && (
        <CompleteList
          complListPopupVisible={complListPopupVisible}
          setComplListPopupVisible={setComplListPopupVisible}
          trainingTracker={trainingTracker}
        />
      )}
    </>
  );
}
